import React from 'react';
import { Box, Button, Link, Typography } from '@mui/material';
import MuiModal, { MuiModalProps } from '../../mui/MuiModal/MuiModal';
import styles from './index.module.scss';
import { useSelector } from 'react-redux';
import { FlattenedUser } from '../../types/user';
import { UserType } from '../../types/generated';
import ExtendedLink from '../ExtendedLink/ExtendedLink';
import { gql } from '@apollo/client';
import { useClientOnboardingModal_GetGlobalVariablesQuery } from '#types';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const getGlobalVariablesQuery = gql`
	query ClientOnboardingModal_getGlobalVariables {
		getGlobalVariables {
			ClientHelpURL
			ClientDemoVideoUrl
		}
	}
`;

export type ClientOnboardingModalProps = Pick<
	MuiModalProps['muiModalProps'],
	'open' | 'onClose'
>;

const ClientOnboardingModal: React.FC<ClientOnboardingModalProps> = ( {
	open,
	onClose,
} ) => {
	const user: FlattenedUser = useSelector( ( state: any ) => state?.user );

	const { data, loading } = useClientOnboardingModal_GetGlobalVariablesQuery();

	const clientUser =
		user?.isLoggedIn && user.userType === UserType.ClientUser
			? user
			: undefined;

	return (
		<MuiModal
			muiModalProps={ {
				open,
				onClose,
				className: styles.container,
				slotProps: { paper: { className: styles.paper } },
			} }
			title={ <>Welcome, { clientUser?.firstNameOne }! 🎉</> }
			description={
				'We are thrilled to have you on RPC. Here are some quick tips to get you started.'
			}
		>
			<Box className={ styles.three }>
				<Box className={ styles.item }>
					<Typography variant='h6'>See RPC in action</Typography>
					<Typography>
						Discover how RPC works, view commonly asked questions like how to
						schedule payments, or get in touch with our support team{ ' ' }
						<ExtendedLink
							target='_blank'
							rel='noreferrer'
							href={ data?.getGlobalVariables.ClientHelpURL }
							loading={ loading }
						>
							here
						</ExtendedLink>
						.
					</Typography>
					<Button
						className={ styles.button }
						LinkComponent={ Link }
						variant='contained'
						target='_blank'
						rel='noreferrer'
						href={ data?.getGlobalVariables.ClientDemoVideoUrl || '' }
						loading={ loading }
					>
						Watch a Demo
					</Button>
				</Box>
				<Box className={ styles.item }>
					<Typography variant='h6'>Pay your vendors</Typography>
					<Typography>
						Looking for invoices sent to you? Click below to view all your
						invoices.
					</Typography>
					<Button
						className={ styles.button }
						LinkComponent={ Link }
						variant='contained'
						target='_blank'
						rel='noreferrer'
						href={ '/invoices' }
					>
						Invoices
					</Button>
				</Box>
				<Box className={ styles.item }>
					<Typography variant='h6'>Set up your wallet</Typography>
					<Typography>
						Paying invoices is as easy as 1, 2, 3. Add a payment method to your
						wallet to get started.
					</Typography>
					<Button
						LinkComponent={ Link }
						variant='contained'
						className={ styles.button }
						href='/wallet'
						onClick={ ( e ) => onClose?.( e, 'fromCode' ) }
					>
						Let's Go
					</Button>
				</Box>
			</Box>
		</MuiModal>
	);
};

export default ClientOnboardingModal;
